import React, { useState } from 'react'
import { Button, Form } from 'react-bootstrap'
import { ApiHelper } from '../../../helpers/apihelper'
import _ from 'lodash'

const ProfanityWords = ({ client }) => {
  const [activeAction, setActiveAction] = useState(null)
  const [wordsInput, setWordsInput] = useState('')
  const [words, setWords] = useState([])

  const handleListWords = () => {
    const body = {
      action: 'retrieve',
      words: ['hii']
    }

    setActiveAction('list')

    ApiHelper(client, 'UPDATE_PROFANITY_WORDS')
      .API(client, body)
      .then((response) => {
        console.log('Profanity Words Response:', response)
        const rawWords = _.get(response, 'data.data', [])

        setWords(Array.isArray(rawWords) ? rawWords : [])
      })
      .catch(() => {})
  }

  const handleAddWords = () => {
    setActiveAction('update')
    setWordsInput('')
  }

  const handleRemoveWords = () => {
    setActiveAction('remove')
    setWordsInput('')
  }

  const handleInputChange = (e) => {
    setWordsInput(e.target.value)
  }

  const handleSubmit = () => {
    const wordList = wordsInput
      .split(',')
      .map((word) => word.trim())
      .filter((word) => word.length > 0)

    const body = {
      action: activeAction,
      words: wordList
    }

    ApiHelper(client, 'UPDATE_PROFANITY_WORDS')
      .API(client, body)
      .then(() => {
        setWordsInput('')
      })
      .catch(() => {})
  }

  const renderListWords = () => {
    if (words.length === 0) {
      return <p>No profanity words found.</p>
    }

    return (
      <Form.Control
        as='textarea'
        rows={8}
        value={words.join(', ')}
        readOnly
      />
    )
  }

  const renderInput = () => {
    if (activeAction !== 'update' && activeAction !== 'remove') {
      return null
    }

    const label = activeAction === 'update'
      ? 'Enter words to update:'
      : 'Enter words to remove:'

    const buttonVariant = activeAction === 'update'
      ? 'outline-success'
      : 'outline-danger'

    return (
      <div className='mt-4'>
        <Form.Group className='profanity-words__group'>
          <Form.Label>{label}</Form.Label>
          <Form.Control
            type='text'
            placeholder='Enter words separated by commas'
            value={wordsInput}
            onChange={handleInputChange}
          />
        </Form.Group>
        <div className='mt-3 text-center'>
          <Button
            variant={buttonVariant}
            disabled={!wordsInput.trim()}
            onClick={handleSubmit}
          >
            Submit
          </Button>
        </div>
      </div>
    )
  }

  return (
    <div className='mis-wrapper profanity-words'>
      <h5 className='heading-title'>Profanity Words</h5>
      <p className='heading-subtext'>
        Manage profanity words
      </p>
      <div className='mt-4'>
        <Button
          variant='outline-success'
          onClick={handleListWords}
        >
          List Words
        </Button>
        <Button
          variant='outline-success'
          className='ms-2'
          onClick={handleAddWords}
        >
          Add Words
        </Button>
        <Button
          variant='outline-danger'
          className='ms-2'
          onClick={handleRemoveWords}
        >
          Remove Words
        </Button>
      </div>
      {activeAction === 'list' && (
        <div className='mt-4 profanity-words__list'>
          <h6 className='profanity-words__list-title'>
  Profanity Words
          </h6>
          {renderListWords()}
        </div>
      )}
      {renderInput()}
    </div>
  )
}

export default ProfanityWords